<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-card>
      <div slot="header">
        <!-- <el-button style="padding: 3px 0" type="text" @click="back">
          <i class="el-icon-arrow-left"></i>
        </el-button> -->
        <el-row style="line-height: 40px">
          <el-col :span="4">
            <span style="font-size: 16px; font-weight: bold"> 學制班管理 </span>
          </el-col>

          <el-col :span="6" :offset="14">
            <!-- <div id="lifeClass_btAdd"> -->
            <el-button
              id="test_lifeClass_btAdd"
              style="float: right; margin-right: 10px"
              type="primary"
              @click="openDialog"
              >新增班級</el-button
            >

            <el-button
              style="float: right; margin-right: 10px"
              class="darkblue"
              @click="scDialogShow=true"
            >
              學程設定
            </el-button>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="6">
          <el-row type="flex" align="middle">
            <el-col :span="5">
              <h6>學年度</h6>
            </el-col>
            <el-select
              v-model="queryForm.year"
              placeholder="請選擇"
              style="display: block; width: 100%"
              @change="query"
            >
              <el-option
                v-for="item in getyear"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-row>
          <br />
          <el-input
            :prefix-icon="queryForm.qString == '' ? 'el-icon-search' : ''"
            placeholder="請輸入 學程、班級編號"
            v-model="queryForm.qString"
            @keyup.enter.native="query"
          ></el-input>
        </el-col>
        <el-col :span="6" :offset="12">
          <br />
          <br />
          <br />
          <el-button
            style="float: right; margin-right: 10px"
            type="success"
            @click="upDialog"
          >
            批次班級升級
          </el-button>
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        @selection-change="isCheckRow"
      >
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column
          prop="studyClass"
          label="學程"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="groupBy"
          label="班級編號"
          width="100"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="lifeClass"
          label="生活班別"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div v-for="item in scope.row.lifeClass" :key="item">
              {{ item }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="mothballType"
          label="成績封存"
          header-align="center"
          align="center"
        >
           <template slot-scope="scope">
                <span v-if="scope.row.mothballType" style="color:red">已封存</span>
                <span v-else style="color: #909398">未封存</span>
           </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="350"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button class="darkblue" size="small" @click="openSetUpDialog(scope.row)" :disabled="scope.row.mothballType"
              >考試內容設定</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="gotoStudyPerson(scope.row)"
              >班員與成績管理</el-button
            >
            <el-button type="danger" size="small" @click="deleteOne(scope.row)"
              >刪除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      title="新增學制班"
      :visible.sync="dialogShow"
      width="40%"
      @close="closeDialog"
    >
      <el-form ref="form" :model="addForm">
        <div style="margin-left: 7em; margin-right: 7em">
              <el-row>
          <el-form-item
            label="年度"
            required
            style="margin-bottom: -1em"
          ></el-form-item>
          <el-select
            v-model="addForm.year"
            placeholder="請選擇"
            style="display: block; width: 100%; margin-bottom: 1em"
          >
            <el-option
              v-for="item in year"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-form-item
            label="學程"
            required
            style="margin-bottom: -1em"
          ></el-form-item>
          <el-select
            v-model="addForm.studyClass"
            placeholder="請選擇"
            style="display: block; width: 100%; margin-bottom: 1em"
          >
            <el-option
              v-for="item in studyClass"
              :key="item.id"
              :label="item.studyName"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <el-form-item
            label="生活班"
            required
            style="margin-bottom: -1em"
          ></el-form-item>
          <el-select
            v-model="addForm.lifeClass"
            multiple
            placeholder="請選擇"
            style="display: block; width: 100%; margin-bottom: 1em"
          >
            <el-option
              v-for="item in lifeClass"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-form-item label="班級編號" style="margin-bottom: -1em">
          </el-form-item>
          <el-input
            id="test_lifeClass_ipAdd"
            style="margin-bottom: 1em"
            placeholder="請輸入班級編號（Ａ、Ｂ班）"
            v-model="addForm.groupBy"
          ></el-input>
          </el-row>
          <br/>

          <el-row type="flex" justify="center">
            <el-button @click="closeDialog">取消</el-button>
            <el-button
              id="test_lifeClass_btAddgo"
              @click="check(false)"
              type="primary"
              >新增</el-button
            >
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      title="升級學制班"
      :visible.sync="upDialogShow"
      width="40%"
      @close="closeDialog"
    >
      <div v-loading="disLoading">
        <el-table :data="upTableData" stripe style="width: 100%">
          <el-table-column
            prop="old"
            label="當前學制班"
            header-align="center"
            align="center"
          >
          </el-table-column>

          <el-table-column header-align="center" align="center" width="50">
            <i class="el-icon-arrow-right"></i>
          </el-table-column>

          <el-table-column
            prop="id"
            label="升級後學制班"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.year }} {{ scope.row.studyClass }}
              {{ scope.row.groupBy }}
            </template>
          </el-table-column>

          <el-table-column header-align="center" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.isNot && scope.row.studyClass != ''"
                style="color: red"
                >  {{ scope.row.year }}{{ scope.row.studyClass }}
              {{ scope.row.groupBy }}重複</span
              >
              <span
                v-if="scope.row.isNot && scope.row.studyClass == ''"
                style="color: red"
                >無法再升級</span
              >
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-row type="flex" justify="center">
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            id="test_lifeClass_btAddgo"
            @click="studyYearUp"
            type="primary"
            :disabled="upNot"
            >升級</el-button
          >
        </el-row>
      </div>
    </el-dialog>

    <el-dialog
      title="考試內容設定"
      :visible.sync="setUpDialogShow"
      width="40%"
      @close="closeDialog"
    >
      <studySetUp
        :clickTime="setUpDialogTime"
        :id="setUpDialogId"
        @close="closeDialog"
      ></studySetUp>
    </el-dialog>

    <el-dialog
      title="學程列表"
      :visible.sync="scDialogShow"
      width="40%"
      @close="closeDialog"
    >
    <el-table :data="studyClass" stripe style="width: 100%"  max-height="300px">
          <el-table-column
            prop="studyName"
            label="學程"
            header-align="center"
            align="center"
          >
          </el-table-column>
           <el-table-column
            prop="upIndex"
            label="升班排序"
            header-align="center"
            align="center"
          >
          </el-table-column>
    </el-table>

    </el-dialog>
  </div>
</template>

<script>
import API from "../../api";
import Utils from "../../utils";
import { InformType } from "@/utils/InformType";
import studySetUp from "./component/studySetUp";

export default {
  name: "studyYear",

  components: { studySetUp },
  data() {
    return {
      isLoading: false,
      disLoading: false,
      tableData: [],
      upTableData: [],
      upDialogShow: false,

      dialogShow: false,

      setUpDialogShow: false,
      setUpDialogTime: null,
      setUpDialogId: NaN,

      scDialogShow:false,

      addForm: {
        year: "",
        studyClass: "",
        lifeClass: null,
        groupBy: "",
      },
      queryForm: {
        year: "",
        qString: "",
      },
      year: [],
      getyear: [],
      studyClass: [],
      lifeClass: [],
      checkRow: [],
      upNot: false,
    };
  },

  created() {
    this.getYear();
    this.getStudyClass();
    this.getlideClass();
  },

  methods: {
    query() {
      console.log("讀取");
      this.isLoading = true;
      API.studyYear.query(this.queryForm).then((res) => {
        this.tableData = res.data;
        console.log(res.data);
        this.isLoading = false;
      });
    },

    openDialog() {
      this.dialogShow = true;
    },
    openSetUpDialog(row) {
      this.setUpDialogTime = new Date();
      this.setUpDialogId = row.id;
      this.setUpDialogShow = true;
    },

    closeDialog() {
      this.getYear();
      this.dialogShow = this.upDialogShow = this.setUpDialogShow = this.scDialogShow= false;
      (this.upTableData = []),
      (this.addForm.year = ""),
      (this.addForm.studyClass = ""),
      (this.addForm.lifeClass = null),
      (this.addForm.groupBy = "");
      // this.query();
    },

    check() {
      if (Utils.Check.isNull(this.addForm.year)) {
        Utils.Message.send("年度不能為空!", InformType.ERROR);
        return;
      }
      if (Utils.Check.isNull(this.addForm.studyClass)) {
        Utils.Message.send("學程不能為空!", InformType.ERROR);
        return;
      }
      if (Utils.Check.isNull(this.addForm.lifeClass)) {
        Utils.Message.send("生活班名稱不能為空!", InformType.ERROR);
        return;
      }

      this.addForm.groupBy = this.addForm.groupBy.replaceAll(/\s+/g, "");

      console.log("檢查成功");
      this.add();
    },

    add() {
      console.log("新增");
      this.isLoading = true;
      API.studyYear
        .add(this.addForm)
        .then(() => {
          Utils.Message.send("新增學制班成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.closeDialog();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    deleteOne(row) {
      this.isLoading = true;
      if (row.id) {
        API.studyYear
          .deleteOne(row.id)
          .then(() => {
            Utils.Message.send("刪除學制班成功!", InformType.SUCCESS);
            this.isLoading = false;
            this.query();
          })
          .catch(() => {
            this.isLoading = false;
            const h = this.$createElement;
            this.$confirm("提示", {
              message: h(
                "div",
                {
                  style: {
                    fontSize: "16px",
                    fontWeight: "bold",
                  },
                },
                [
                  h(
                    "p",
                    {
                      style: {
                        fontSize: "30px",
                      },
                    },
                    "注意！"
                  ),
                  h("br", ""),
                  h("p", "須先將班級內部學員刪除"),
                  h("p", "是否確定刪除書目？"),
                ]
              ),
              showConfirmButton:false,
              cancelButtonClass:"cb",
              cancelButtonText: "確認",
              type: "warning",
              center: true,
            }).catch(() => {});
          });
      }
    },

    getYear() {
      let year = new Date().getFullYear();
      this.year = [];
      this.year.push(year + 1);
      this.year.push(year);
      this.year.push(year - 1);
      this.year.push(year - 2);
      this.year.push(year - 3);
      console.log("讀取年度");
      API.studyYear.getYear().then((res) => {
        this.getyear = res.data;
        this.queryForm.year = this.getyear.length > 0 ? this.getyear[0] : "";
        this.query();
      });
      // console.log(this.year);
    },

    getStudyClass() {
      console.log("讀取學程");
      API.studyYear.getStudyClass().then((res) => {
        this.studyClass = res.data;
      });
    },

    getlideClass() {
      console.log("讀取生活班");
      API.lifeClass.findLifeClass().then((res) => {
        this.lifeClass = res.data;
      });
    },

    gotoStudyPerson(row) {
      this.$router.push({ path: `/studyPerson?id=${row.id}` });
    },

    isCheckRow(val) {
      this.checkRow = val;
      console.log("選中row: ", this.checkRow);
    },

    upDialog() {
      if (this.checkRow.length < 1) {
        Utils.Message.send("尚未勾選升級資料!", InformType.ERROR);
        return;
      }
      this.disLoading = true;
      this.upDialogShow = true;
      API.studyYear
        .upCheck(this.queryForm.year, this.checkRow)
        .then((res) => {
          console.log(res.data);
          this.upTableData = res.data;
          if (this.upTableData.length > 0) {
            let aa = this.upTableData.filter((a) => {
              return a.isNot == true;
            });
            if (aa.length > 0) this.upNot = true;
            else this.upNot = false;
          } else this.upNot = false;

          this.disLoading = false;
        })
        .catch(() => {
          this.disLoading = false;
        });
    },
    studyYearUp() {
      this.disLoading = true;
      API.studyYear
        .studyYearUp(this.queryForm.year, this.upTableData)
        .then(() => {
          Utils.Message.send("學制班升級成功!", InformType.SUCCESS);
          this.disLoading = false;
          this.closeDialog();
        })
        .catch(() => {
          this.disLoading = false;
        });
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
.cb {
  background-color: #527bae;
  color: #ffffff;
}
</style>